const STORAGE_KEY = 'pos_graciela_local_print_settings';

const DEFAULT_SETTINGS = {
  enabled: true,
  // 'auto' por default (SPEC_COBRO_PERFORMANCE_v0.1.md, Ampliación 1, RF-15):
  // 'confirm' metía un click humano en cada venta. El modo 'confirm' sigue
  // disponible para quien lo quiera, pero deja de ser el comportamiento
  // por omisión.
  invoicePrintMode: 'auto',
  printerName: '',
  backend: 'raw',
  copies: 1,
  cut: true,
  apiKey: ''
};

function sanitizeSettings(raw = {}) {
  const next = {
    ...DEFAULT_SETTINGS,
    ...(raw && typeof raw === 'object' ? raw : {})
  };

  if (!['disabled', 'auto', 'confirm'].includes(next.invoicePrintMode)) {
    next.invoicePrintMode = DEFAULT_SETTINGS.invoicePrintMode;
  }

  if (!['raw', 'tcp9100'].includes(next.backend)) {
    next.backend = DEFAULT_SETTINGS.backend;
  }

  next.enabled = Boolean(next.enabled);
  next.printerName = String(next.printerName || '').trim();
  next.apiKey = String(next.apiKey || '').trim();
  next.copies = Math.min(20, Math.max(1, Number(next.copies) || DEFAULT_SETTINGS.copies));
  next.cut = Boolean(next.cut);

  if (next.invoicePrintMode === 'disabled') {
    next.enabled = false;
  }

  return next;
}

function getSettings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    return sanitizeSettings(JSON.parse(raw));
  } catch (error) {
    console.warn('No se pudo leer la configuracion local de impresion', error);
    return { ...DEFAULT_SETTINGS };
  }
}

function saveSettings(settings) {
  const sanitized = sanitizeSettings(settings);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(sanitized));
  return sanitized;
}

export default {
  STORAGE_KEY,
  DEFAULT_SETTINGS,
  getSettings,
  saveSettings,
  sanitizeSettings
};
